import { ProductSynopses } from 'CommonData/poco/productSynopses';

export class ProductSynopsesMapper {
    public static map(data: any): Array<ProductSynopses> {
        if (!data) {
            throw 'No data for mapper: ProductSynopsesMapper';
        }

        return data.productSynopses.map((ps: any) => 
            new ProductSynopses({
                id: ps.id,
                name: ps.name,
                description: ps.description,
                websiteUrl: ps.websiteUrl,
                heroImageUrl: ps.heroImages[0]?.url,
                skus: ps.skus,
                installPricePerM2Gross: ps.installPricePerM2Gross,
                bimUrls: ps.bimdamUrls,
                datasheetDocumentUrls: ps.datasheetDocumentUrls,
                epdDocumentUrls: ps.epdDocumentUrls,
                commercialQuoteSku: ps.commercialQuoteSku
            })
        );
    }
} 